<template>
  <div class="d-flex">
    <UserAvatar
      v-for="(item, index) in makeUserAvatarsList([...list])"
      :theme="theme"
      :size="size"
      :class="{ lefted: index }"
      :short-name="item.shortName"
      :tooltip="item.tooltip"
    >
    </UserAvatar>
  </div>
</template>

<script setup>
const props = defineProps({
  list: {
    type: Array,
    default: [],
  },
  theme: {
    type: String,
    defualt: "white",
  },
  size: {
    type: String,
    defualt: "base",
  },
  limit: {
    type: Number,
    default: 3,
  },
  shortName: {
    type: Function,
    default: null,
  },
  tooltip: {
    type: Function,
    default: null,
  },
});

const makeUserAvatarsList = (listIds) => {
  const mappedList = listIds.slice(0, props.limit);

  const countOfDifferenceAfterMapAndSlice =
    props.list.length - mappedList.length;

  if (countOfDifferenceAfterMapAndSlice) {
    const excludedItems = listIds.slice(props.limit);

    mappedList.push({
      shortName: `+${countOfDifferenceAfterMapAndSlice}`,
      tooltip: excludedItems.map(({ tooltip }) => tooltip).join(", "),
    });
  }
  return mappedList;
};
</script>

<style lang="scss" scoped>
.lefted {
  margin-left: -4px;
  //z-index: 2;
}
</style>
